export const GET_MAPPING_DATA_REQUEST="GET_MAPPING_DATA_REQUEST"
export const GET_MAPPING_DATA_SUCCESS="GET_MAPPING_DATA_SUCCESS"
export const GET_MAPPING_DATA_FAILURE="GET_MAPPING_DATA_FAILURE"